import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
import {
    RuntimeConfigurationOperationResult,
    RuntimeConfigurationOption,
} from '../../../pages/RuntimeConfiguration/runtimeConfiguration.types';

export type UpdateRuntimeConfigurationValueResult = RuntimeConfigurationOperationResult & {
    key?: string;
    newVersion?: number;
    Key?: string;
    NewVersion?: number;
};

export type CreateRuntimeConfigurationResult = RuntimeConfigurationOperationResult & {
    id?: number;
    key?: string;
    currentVersion?: number;
    Id?: number;
    Key?: string;
    CurrentVersion?: number;
};

export type CreateRuntimeConfigurationPayload = {
    key: string;
    displayName: string;
    description?: string;
    valueType: string;
    inputMode: string;
    options?: RuntimeConfigurationOption[];
    initialValue: unknown;
    changeNote?: string;
};

const CreateRuntimeConfiguration = (data: CreateRuntimeConfigurationPayload): Promise<CreateRuntimeConfigurationResult> =>
    request({
        url: ApiURL.Command.RUNTIME_CONFIGURATION_CREATE,
        method: RequestType.POST,
        data,
    });

const UpdateRuntimeConfigurationValue = (
    key: string,
    data: { value: unknown; changeNote?: string }
): Promise<UpdateRuntimeConfigurationValueResult> =>
    request({
        url: ApiURL.Command.RUNTIME_CONFIGURATION_UPDATE_VALUE(key),
        method: RequestType.PUT,
        data,
    });

const UpdateRuntimeConfigurationMetadata = (
    key: string,
    data: {
        displayName: string;
        description?: string;
        valueType?: string;
        inputMode: string;
        options?: RuntimeConfigurationOption[];
    }
): Promise<RuntimeConfigurationOperationResult> =>
    request({
        url: ApiURL.Command.RUNTIME_CONFIGURATION_UPDATE_METADATA(key),
        method: RequestType.PUT,
        data,
    });

const PublishRuntimeConfigurationVersion = (
    key: string,
    data: { sourceVersion: number; changeNote?: string }
): Promise<UpdateRuntimeConfigurationValueResult> =>
    request({
        url: ApiURL.Command.RUNTIME_CONFIGURATION_PUBLISH_VERSION(key),
        method: RequestType.POST,
        data,
    });

const DeleteRuntimeConfiguration = (key: string): Promise<RuntimeConfigurationOperationResult> =>
    request({
        url: ApiURL.Command.RUNTIME_CONFIGURATION_DELETE(key),
        method: RequestType.DELETE,
    });

const RuntimeConfigurationCommand = {
    CreateRuntimeConfiguration,
    UpdateRuntimeConfigurationValue,
    UpdateRuntimeConfigurationMetadata,
    PublishRuntimeConfigurationVersion,
    DeleteRuntimeConfiguration,
};

export default RuntimeConfigurationCommand;
